import React from 'react';
const NavBar = (props) => {
    const { nbs } = props;
    return (
        <section className="ml-auto w3-hide-small w3-hide-medium">
            <div className="d-flex flex-row h-100" style={{ fontSize: '13px' }}>
                <a href="/" className={`margin-left-double white align-self-center hind ${nbs === 'home' ? 'selected' : ''}`}>HOME</a>
                <a href="/new" className={`margin-left-double white align-self-center hind ${nbs === 'whatsnew' ? 'selected' : ''}`}>WHAT'S NEW</a>
                <a href="/tournaments" className={`margin-left-double white align-self-center hind ${nbs === 'tournaments' ? 'selected' : ''}`}>TOURNAMENTS</a>
                <a href="/passport" className={`margin-left-double white align-self-center hind ${nbs === 'passport' ? 'selected' : ''}`}>PASSPORT</a>
                <a href="/rankings" className={`margin-left-double white align-self-center hind ${nbs === 'rankings' ? 'selected' : ''}`}>RANKINGS</a>
                <a href="/alumni" className={`margin-left-double white align-self-center hind ${nbs === 'alumni' ? 'selected' : ''}`}>ALUMNI</a>
                <a href="/information" className={`margin-left-double white align-self-center hind ${nbs === 'information' ? 'selected' : ''}`}>INFORMATION</a>
                <a href="/contact" className={`margin-left-double white align-self-center hind ${nbs === 'contact' ? 'selected' : ''}`}>CONTACT</a>
                <a href="/faqs" className={`margin-left-double white align-self-center hind ${nbs === 'faqs' ? 'selected' : ''}`}>FAQ</a>
            </div>
        </section>
    );
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/components/layouts/navbar.js